import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LandingPage from "../pages/landing/LandingPage";

export function RootRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <LandingPage />;
}
